const Breadcrumb = {
  baseStyle: {
    link: {
      backgroundColor: "transparent",
      textDecoration: "inherit",
      color: "text-secondary",
      fontSize: "text-sm",
      fontWeight: "medium",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      minWidth: "0",
      _activeLink: {
        color: "text-primary"
      },
      _hover: {
        color: "slate.600"
      },
      _dark: {
        _hover: {
          color: "grayscale.300"
        }
      }
    },
    separator: {
      width: "1.5rem",
      height: "1.5rem"
    }
  },
  variants: {
    primary: {
      link: {
        color: "blue.500",
        _hover: {
          color: "blue.600"
        },
        _dark: {
          _hover: {
            color: "blue.600"
          }
        }
      }
    }
  }
};

export { Breadcrumb };
